import { z } from "zod";

/**
 * @description The JSON response received from the resource
 */
export const postProxy200Schema = z.object({});

export type PostProxy200 = z.infer<typeof postProxy200Schema>;

export const postProxyMutationRequestSchema = z.object({
  resource: z.coerce
    .string()
    .describe(
      "The resource to request from the CRM API, e.g. \"/api/data/v9.0/fmfi_opportunityitems?$select=fmfi_itemid,fmfi_opportunityid&$filter=fmfi_opportunityid eq '3bb0c379-0523-ef11-840a-000d3a2950fa'\"",
    )
    .optional(),
});

export type PostProxyMutationRequest = z.infer<typeof postProxyMutationRequestSchema>;

export const postProxyMutationResponseSchema = z.lazy(() => postProxy200Schema);

export type PostProxyMutationResponse = z.infer<typeof postProxyMutationResponseSchema>;
